// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const BrandingAPI = {
    /**
     * GetBrandingDetails is used to get branding details
     */
    GetBrandingDetails(fn, req) {
        return fn(`/branding-api/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteLogo(fn, req) {
        return fn(`/branding-api/v1/logo?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
};
